export default __webpack_public_path__ + "static/media/default.042eb332.jpg";